<template>
  <div class="flex justify-center">
    <input
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      @paste="onPaste"
      type="text"
      autofocus
      class="otp-digit-box font-semibold"
      :maxlength="otpDigitCount"
      autocomplete="off"
    />
  </div>
</template>

<script>
export default {
  name: "OtpField",

  props: {
    otpDigitCount: { default: 6, type: Number, required: false },
    modelValue: { default: "", type: String, required: true },
  },

  emits: ["update:modelValue", "paste"],

  data() {
    return {}
  },

  methods: {
    onPaste(event) {
      const value = (event.clipboardData || window.clipboardData).getData("text").trim()

      if (value.length === this.otpDigitCount) {
        this.$emit("paste", value)
      }
    },
  },
}
</script>

<style scoped></style>
